import { OMenuElement } from "../elements/OMenuElement";

export class IOMenu extends OMenuElement {}
